import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
Vue.config.productionTip = false;
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

Vue.use(VuePlyr, {
  plyr: {}
})
import { BootstrapVue } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faFacebookF,
  faSpotify,
  faSoundcloud,
  faBandcamp,
  faInstagram,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '@/assets/css/animations.css'
import '@/assets/css/global.css'
import '@/assets/css/fonts.css'

library.add(faUserSecret);
library.add(faFacebookF, faSpotify, faSoundcloud, faBandcamp, faInstagram, faYoutube);

Vue.use(BootstrapVue)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.mixin({
  methods: {
    async apiRequest(method, route, data = null) {

      let address = `https://api.asanbudapest.com${route}`
      let output;
      let parameters = {
        method: method,
        url: address,
        data: data,
      }
      await this.axios(parameters).then((response) => {
        output = response.data;
      }).catch((errors) => {
        console.log('errors', errors);
      });
      return output;
    },
  }
})

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
